import styled from 'styled-components';
import tw from 'twin.macro';
import { toastActions } from '../../../store/toastStore';
import { useSnapshot } from 'valtio';
import { toastStore } from '../../../store/toastStore';

const ModalOverlay = styled.div`
  ${tw`fixed inset-0`}
  z-index: var(--z-modal);
  background-color: rgb(17 24 39 / 0.55);
  backdrop-filter: blur(2px);
  animation: ui-fade-in var(--transition-modal);
`;

const ToastAlertContainer = styled.div`
  ${tw`fixed inset-0 flex items-center justify-center p-4`}
  z-index: var(--z-modal);
`;

const AlertContainer = styled.div`
  ${tw`w-full max-w-sm p-6 mx-auto`}
  background-color: var(--color-bg-elevated);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-overlay);
  animation: ui-pop-in var(--transition-modal);
`;

const AlertTitle = styled.h3`
  ${tw`text-lg font-semibold mb-2`}
  color: var(--color-text-primary);
  font-family: var(--font-display);
  letter-spacing: -0.01em;
`;

const AlertMessage = styled.div`
  ${tw`text-sm leading-6 mb-2`}
  color: var(--color-text-secondary);
`;

const ButtonContainer = styled.div`
  ${tw`flex flex-col-reverse sm:flex-row sm:justify-end gap-2 mt-5`}
`;

const baseButton = tw`inline-flex items-center justify-center h-10 px-4 text-sm font-semibold rounded-lg border cursor-pointer focus:outline-none`;

const CancelButton = styled.button`
  ${baseButton}
  background-color: var(--color-bg);
  color: var(--color-text-primary);
  border-color: var(--color-border-strong);
  transition: background-color var(--transition-normal);
  &:hover {
    background-color: var(--color-bg-secondary);
  }
`;

const ConfirmButton = styled.button`
  ${baseButton}
  background-color: var(--color-black);
  color: var(--color-on-primary);
  border-color: var(--color-black);
  box-shadow: var(--shadow-xs);
  transition: background-color var(--transition-normal);
  &:hover {
    background-color: var(--color-black-hover);
  }
`;

export const ToastAlertModal = () => {
  const { isToastAlertShowing } = useSnapshot(toastStore);
  const toast = useSnapshot(toastStore);

  const handleConfirm = () => {
    if (toast.onConfirm) {
      toast.onConfirm();
    }
    toastActions.hideToastAlert();
  };

  const handleCancel = () => {
    if (toast.onCancel) {
      toast.onCancel();
    }
    toastActions.hideToastAlert();
  };
  if (isToastAlertShowing) {
    return (
      <>
        <ModalOverlay />
        <ToastAlertContainer>
          <AlertContainer role="alertdialog" aria-modal="true">
            <AlertTitle>{toast.toastTitle}</AlertTitle>
            {toast.toastMessage && <AlertMessage>{toast.toastMessage}</AlertMessage>}
            {toast.confirmMessage && <AlertMessage>{toast.confirmMessage}</AlertMessage>}
            <ButtonContainer>
              <CancelButton type="button" onClick={handleCancel}>
                {toast.cancelText}
              </CancelButton>
              <ConfirmButton type="button" onClick={handleConfirm}>
                {toast.confirmText}
              </ConfirmButton>
            </ButtonContainer>
          </AlertContainer>
        </ToastAlertContainer>
      </>
    );
  }
  return null;
};
